import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import { Ref } from 'vue';
import { GetSegmentExternalIdListRequest } from '@/api/segment-external/get-segment-external-id-list.request';

export class SegmentExternalApiResources {
  constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly multibrandApiHost: Ref<string>,
  ) {}

  public get getSegmentExternalIdListRequest(): GetSegmentExternalIdListRequest {
    return new GetSegmentExternalIdListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/segment/externalId`,
      HttpMethods.GET,
    );
  }
}
